export default __webpack_public_path__ + "static/media/profiili-white.76b26b09.svg";